// Temporary until eslint config is updated
import React from 'react';

import { ReactComponent as CheckIcon } from 'assets/check.svg';
import { ReactComponent as EditIcon } from 'assets/edit.svg';
import { useAppContext, useLocaleContext } from 'context';
import { Input, Typography } from 'kill-components';
import { getCurrencyFormat, getCurrencySymbol } from 'wtb-utils';

import useStyles from './DonateDifferentAmount.styles';

const DonateDifferentAmount = () => {
  const { classes } = useStyles();

  const {
    currency,
    minimumAmount,
    isLoading,
    manualDonation,
    setManualDonation,
    isManualDonation,
    setIsManualDonation
  } = useAppContext();
  const { locale, translate } = useLocaleContext();

  const handleDifferentAmountClick = () => {
    if (isLoading) return;

    setIsManualDonation(true);
  };

  const handleAmountChange = (event) => {
    setManualDonation(event.target.value);
  };

  return (
    <>
      {!isManualDonation && (
        <div className={classes.buttonContainer}>
          <button className={classes.button} type="button" onClick={handleDifferentAmountClick}>
            <Typography className={classes.buttonText} color="primary" variant="caption">{translate('donateDifferentAmount')}</Typography>
            <EditIcon className={classes.icon} />
          </button>
        </div>
      )}

      {isManualDonation && (
        <div className={classes.donationContainer}>
          <div className={classes.donation}>
            <div className={classes.header}>
              <Typography fontWeight="bold">{translate('manuallyDonating.title')}</Typography>
              <CheckIcon className={classes.icon} />
            </div>

            <Input
              className={classes.input}
              helperText={translate('manuallyDonating.minimumAmount', {
                amount: getCurrencyFormat(minimumAmount, currency, locale, { decimals: 0 })
              })}
              inputProps={{ className: classes.inputContent }}
              InputProps={{
                endAdornment: (
                  <div className={classes.inputCurrency}>
                    <Typography color="textSecondary">{getCurrencySymbol(currency)}</Typography>
                  </div>
                )
              }}
              isClearable={false}
              label={translate('manuallyDonating.inputLabel')}
              thousandSeparator=" "
              type="number"
              value={manualDonation}
              variant="filled"
              onChange={handleAmountChange}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DonateDifferentAmount;
